import request from "@/api/request";
import { getAuthToken } from "@/storage/authStorage";

export function loadLocale() {
    const token = getAuthToken()
    const isAuthenticated = token && token !== ''
    if (!isAuthenticated) {
        const lang = 'DE'
        return request({
            url: `/locale/${lang}`,
            method: 'get',
        });
    }

    return request({
        url: `/locale`,
        method: 'get',
    });
}
